import React, { useState } from "react";
import styled from "styled-components";
import { AiOutlineDown } from "react-icons/ai";

const SideBar = ({ item }) => {
  const [open, setOpen] = useState(false);

  if (item.children) {
    return (
      <SideBarItems  onClick={() => setOpen(!open)}>
        <SideBarTitle>
          <span>
            {item.icon && <item.icon />}
            {item.title}
          </span>
          <AiOutlineDown
            style={{
              cursor: "pointer",
              transition: "transform .3s",
              transform: `${open ? " rotate(180deg) " : " rotate(0deg) "}`,
            }}
            className="toggler-btn"
            onClick={() => setOpen(!open)}
          />
        </SideBarTitle>
        <SidebarContent style={{ height: `${open ? "auto" : "0px"}` }}>
          {item.children.map((child, index) => (
            <SideBar key={index} item={child} />
          ))}
        </SidebarContent>
      </SideBarItems>
    );
  } else if (item.adlink){
    return (
      <a href={item.adlink} rel="noreferrer"  target="_blank" >
      <SideBarItems>
        <SideBarTitle>
          <a href={item.adlink} rel="noreferrer"  target="_blank" >
            <span  style={{
              fontWeight: 700,
            }} >
              {item.icon && <item.icon />} {item.title}
            </span>
          </a>
        </SideBarTitle>
      </SideBarItems>
      </a>
    );
  }
   else {
    return (
      <a href={item.path || "#"}>
      <SideBarItems>
        <SideBarTitle>
          <a href={item.path || "#"}>
            <span>
              {item.icon && <item.icon />} {item.title}
            </span>
          </a>
        </SideBarTitle>
      </SideBarItems>
      </a>
    );
  }
};

export default SideBar;

const SideBarItems = styled.div`
  padding: 0.74em 1em;
  color: #080808;
  transition: background-color 0.2s;
  display: block;
  border-radius: 4.9px;
  &:hover {
    background-color: rgba(241, 193, 224, 0.1);
  }
  a {
    color: black;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
    svg {
      display: inline-block;
      width: 1.5em;
    }
  }
`;

const SideBarTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1.2em;
  align-items: center;
  svg {
    display: inline-block;
    width: 1.5em;
  }
`;

const SidebarContent = styled.div`
  padding-top: 0.24em;
  overflow: hidden;
`;

// item.children ? (
//   <SideBarItems key={i}>
//     <SideBarTitle>
//       <span>
//         {item.icon && <item.icon />}
//         {item.title}
//       </span>
//       <AiOutlineDown
//         style={{
//           cursor: "pointer",
//           transition: "transform .3s",
//           transform: `${
//             open ? " rotate(180deg) " : " rotate(0deg) "
//           }`,
//         }}
//         className="toggler-btn"
//         onClick={() => setOpen(!open)}
//       />
//     </SideBarTitle>
//     <SidebarContent style={{ height: `${open ? "auto" : "0px"}` }}>
//       {item.children.map((child, i) =>  item.children ? (
//   <SideBarItems key={i}>
//     <SideBarTitle>
//       <span>
//         {item.icon && <item.icon />}
//         {item.title}
//       </span>
//       <AiOutlineDown
//         style={{
//           cursor: "pointer",
//           transition: "transform .3s",
//           transform: `${
//             open ? " rotate(180deg) " : " rotate(0deg) "
//           }`,
//         }}
//         className="toggler-btn"
//         onClick={() => setOpen(!open)}
//       />
//     </SideBarTitle>
//     <SidebarContent style={{ height: `${open ? "auto" : "0px"}` }}>
//       {item.children}
//     </SidebarContent>
//   </SideBarItems>
// ) : (
//   <SideBarItems key={i}>
//     <a href={item.path || "#"}>
//       <span>
//         {item.icon && <item.icon />} {item.title}
//       </span>
//     </a>
//   </SideBarItems>
// ) )}
//     </SidebarContent>
//   </SideBarItems>
// ) : (
//   <SideBarItems key={i}>
//     <a href={item.path || "#"}>
//       <span>
//         {item.icon && <item.icon />} {item.title}
//       </span>
//     </a>
//   </SideBarItems>
// )

// import * as React from 'react';
// import Box from '@mui/material/Box';
// import SwipeableDrawer from '@mui/material/SwipeableDrawer';
// import Button from '@mui/material/Button';
// import List from '@mui/material/List';
// import Divider from '@mui/material/Divider';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';

// export default function SideBar() {
//   const [state, setState] = React.useState({
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   });

//   const toggleDrawer = (anchor, open) => (event) => {
//     if (
//       event &&
//       event.type === 'keydown' &&
//       (event.key === 'Tab' || event.key === 'Shift')
//     ) {
//       return;
//     }

//     setState({ ...state, [anchor]: open });
//   };

//   const list = (anchor) => (
//     <Box
//       sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
//       role="presentation"
//       onClick={toggleDrawer(anchor, false)}
//       onKeyDown={toggleDrawer(anchor, false)}
//     >
//       <List>
//         {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
//           <ListItem key={text} disablePadding>
//             <ListItemButton>
//               <ListItemIcon>
//                 {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//               </ListItemIcon>
//               <ListItemText primary={text} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//       <Divider />
//       <List>
//         {['All mail', 'Trash', 'Spam'].map((text, index) => (
//           <ListItem key={text} disablePadding>
//             <ListItemButton>
//               <ListItemIcon>
//                 {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//               </ListItemIcon>
//               <ListItemText primary={text} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );

//   return (
//     <div>
//       {['right'].map((anchor) => (
//         <React.Fragment key={anchor}>
//           <Button onClick={toggleDrawer(anchor, true)}>me</Button>
//           <SwipeableDrawer
//             anchor={anchor}
//             open={state[anchor]}
//             onClose={toggleDrawer(anchor, false)}
//             onOpen={toggleDrawer(anchor, true)}
//           >
//             {list(anchor)}
//           </SwipeableDrawer>
//         </React.Fragment>
//       ))}
//     </div>
//   );
// }